import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { updateMode } from "../../redux/reducers/ModeReducer";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import ContentContainer from "../../components/ContentContainerComp/ContentContainer";
import s from "./style.module.css";

const LoginContainer = () => {
  let navigate = useNavigate();
  const [userObj, setUserObj] = useState({
    email: "",
    password: "",
  });
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const handleChange = (e) => {
    const { name, value } = e.target;
    const obj = { ...userObj, [name]: value };
    setUserObj(obj);
  };
  const onSubmit = () => {
    const { email, password } = userObj;
    const authentication = getAuth();
    signInWithEmailAndPassword(authentication, email, password)
      .then((res) => {
        if (res.user.email === "teacher@test.com") {
          localStorage.setItem("authUser", res.user.email);
          navigate("/dashboard");
        } else {
          localStorage.setItem("authUser", res.user.email);
          dispatch(updateMode({ mode: 1, step: 1 }));
        }
      })
      .catch((err) => {
        setShowModal(true);
        console.log(err);
      });
  };
  // console.log(first);
  return (
    <ContentContainer
      LoginType
      typeHeader={1}
      onCenter
      textHeader="ยินดีต้อนรับ"
      textHeaderColor="#ffffff"
      disableNext={1}
      disableBack={1}
      onsubmit={onSubmit}
    >
      <Modal
        // {...props}
        show={showModal}
        onHide={() => setShowModal(false)}
        animation={true}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body
          size="lg"
          style={{
            paddingTop: "40px",
            textAlign: "center",
          }}
        >
          <h4>usename หรือ password ผิด</h4>
          <p>กรุณาลองใหม่อีกครั้ง</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
      <div className={s.Container}>
        <div className={s.inputContainer}>
          <input
            className={s.inputStyle}
            onChange={handleChange}
            placeholder="ชื่อผู้ใช้"
            name="email"
          />
          <input
            className={s.inputStyle}
            onChange={handleChange}
            placeholder="รหัสผ่าน"
            type="password"
            name="password"
          />
        </div>
      </div>
    </ContentContainer>
  );
};

export default LoginContainer;
